import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAppState from 'context/useAppState';

// User eksternal (is_external_flag true) hanya boleh mengakses modul Report Adira.
// Sidebar sudah memfilter menunya, tapi tanpa guard ini URL-nya masih bisa diketik manual.
const EXTERNAL_ALLOWED_PREFIX = '/report-seller';
const EXTERNAL_HOME_PATH = '/report-seller/unit-acceptance';

export default function ProtectedRoute() {
  const { isAuthenticated, data } = useAppState((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const isExternal = data?.user?.is_external_flag === true;
  const isExternalBlocked = isExternal && !location.pathname.startsWith(EXTERNAL_ALLOWED_PREFIX);

  useEffect(() => {
    const redirectLink = encodeURIComponent(location.pathname + location.search);

    if (!isAuthenticated) {
      navigate(`/login?continue=${redirectLink}`, { replace: true, state: location });
      return;
    }

    // Sudah login sebagai user eksternal tapi membuka halaman di luar Report Adira
    if (isExternalBlocked) {
      navigate(EXTERNAL_HOME_PATH, { replace: true });
    }
  }, [navigate, location, isAuthenticated, isExternalBlocked]);

  // Hindari render konten halaman terlarang sebelum redirect selesai
  if (isExternalBlocked) return null;

  return (
    <Suspense fallback="...">
      <Outlet />
    </Suspense>
  );
}
